module.exports = __webpack_public_path__ + "static/media/Web_App_Template.a1002f35.gif";